import React, {useState, Fragment} from 'react';
import Error from './Error';

const Formulario = ({busqueda, guardarBusqueda, guardarConsultar}) => {

    // extraer ciudad y pais:
    const {ciudad, pais} = busqueda;

    const [error, guardarError] = useState(false);

    // funcion para leer los valores de la busqueda:
    const valores = e =>{
        guardarBusqueda({
            ...busqueda,
            [e.target.name] : e.target.value
        });
    }

    // submit en el formulario
    const buscarClima = e =>{
        e.preventDefault();
        // validar
        if(ciudad.trim() === '' || pais.trim() === ''){
            guardarError(true);
            return;
        }
        guardarError(false);
        // pasar los datos al componente principal
        guardarConsultar(true);
    }

    return ( 
        <Fragment>
            <section className='d-column align-items-center'>
            <h1 className='text-center text-uppercase'>Clima React <span><i class="fas fa-sun"></i></span></h1>
            <form
            onSubmit={buscarClima}
            className='mt-5 form'
        >
            {error ? <Error mensaje='Ambos campos son obligatorios' /> : null}
            <div className='form-group'>
                <label>Ciudad: </label>
                <input 
                    className='form-control'
                    type='text'
                    name='ciudad'
                    id='ciudad'
                    value={ciudad}
                    onChange={valores}
                />
            </div>
            <div className='form-group'>
                <label>Pais: </label>
                <select
                    className='form-control'
                    name='pais'
                    id='pais'
                    value={pais}
                    onChange={valores}
                >
                    <option value=''>-- Seleccione un pais --</option>
                    <option value="US">Estados Unidos</option>
                    <option value="MX">México</option>
                    <option value="AR">Argentina</option>
                    <option value="CO">Colombia</option>
                    <option value="CR">Costa Rica</option>
                    <option value="ES">España</option>
                    <option value="PE">Perú</option>
                </select>
            </div>
            <button
                type='submit'
                className='btn btn-warning'
            >Buscar Clima</button>
        </form>
            </section>
            
        </Fragment>
     );
}
 
export default Formulario;